// backoffice/src/pages/Signup.tsx
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { useUser } from "../lib/UserContext";

interface FormState {
  email: string;
  password: string;
  prenom: string;
  nom: string;
  twilio_numero: string;
}

/* URL de l’API FastAPI (Render)  ───────────────────────────────── */
const API_URL =
  import.meta.env.VITE_API_URL || "https://whatsapp-healthcare.onrender.com";

export default function Signup() {
  const admin = useUser();                         // profil ou null
  const [token, setToken] = useState<string | null>(null);
  const [form, setForm] = useState<FormState>({
    email: "", password: "", prenom: "", nom: "", twilio_numero: ""
  });
  const [msg, setMsg] = useState<string | null>(null);

  /* Récupération du JWT admin ──────────────────────────────────── */
  useEffect(() => {
    (async () => {
      const { data } = await supabase.auth.getSession();
      setToken(data.session?.access_token || null);
    })();
  }, []);

  /* Accès réservé admin ────────────────────────────────────────── */
  if (!admin || admin.role !== "admin") {
    return <div className="p-6 text-gray-500">Accès réservé aux administrateurs.</div>;
  }

  /* Soumission du formulaire ───────────────────────────────────── */
  const handleCreate = async () => {
    if (!token) { setMsg("Token admin introuvable"); return; }
    if (!form.email || !form.password || !form.twilio_numero) {
      setMsg("Champs requis manquants"); return;
    }

    setMsg("Création en cours…");

    try {
      const res = await fetch(`${API_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });

      /* Gestion e-mail déjà pris -------------------------------- */
      if (res.status === 409) {
        setMsg("Cet email est déjà enregistré.");
        return;
      }

      const text   = await res.text();
      const detail = (() => {        // tente de décoder JSON ou garde brut
        try { return JSON.parse(text).detail; }
        catch { return text; }
      })();

      setMsg(detail);
      if (res.ok) {
        setForm({ email: "", password: "", prenom: "", nom: "", twilio_numero: "" });
      }
    } catch (err) {
      console.error(err);
      setMsg("Erreur réseau ou CORS");
    }
  };

  /* Rendu ------------------------------------------------------- */
  return (
    <div className="max-w-lg mx-auto p-6 font-sans text-gray-800">
      <h1 className="text-2xl font-semibold mb-6 text-primary">➕ Create the clinic account</h1>

      {(["email","password","prenom","nom","twilio_numero"] as const).map((k) => (
        <div key={k} className="mb-4">
          <label className="block text-sm mb-1 capitalize">{k.replace("_"," ")}</label>
          <input
            type={k === "password" ? "password" : "text"}
            className="w-full border px-3 py-2 rounded"
            value={form[k]}
            onChange={(e) => setForm({ ...form, [k]: e.target.value })}
          />
        </div>
      ))}

      <button
        onClick={handleCreate}
        className="bg-primary text-white px-4 py-2 rounded"
      >
        Create
      </button>

      {msg && <p className="mt-4 text-sm text-gray-700">{msg}</p>}
    </div>
  );
}
